import React, { createContext, useContext, ReactNode } from 'react';
import { AdminUser } from '../services/adminService';
import { useAdminAuth } from '../hooks/useAdminAuth';

interface AdminAuthContextType {
  adminUser: AdminUser | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  signIn: (email: string, password: string) => Promise<{ success: boolean; message: string }>;
  signInWithGoogle: (credential: string) => Promise<{ success: boolean; message: string }>;
  signOut: () => Promise<void>;
  refreshSession: () => Promise<void>;
}

const AdminAuthContext = createContext<AdminAuthContextType | undefined>(undefined);

interface AdminAuthProviderProps {
  children: ReactNode;
}

export const AdminAuthProvider: React.FC<AdminAuthProviderProps> = ({ children }) => {
  const auth = useAdminAuth();

  return <AdminAuthContext.Provider value={auth}>{children}</AdminAuthContext.Provider>;
};


export const useAdminAuthContext = (): AdminAuthContextType => {
  const context = useContext(AdminAuthContext);

  if (context === undefined) {
    throw new Error('useAdminAuthContext must be used within an AdminAuthProvider');
  }

  return context;
};

export default AdminAuthContext;
